import {useState,useEffect,useRef} from "react";
import {Link, Routes , Route} from "react-router-dom";
import logo from "../assets/logo.png";
import { FiMenu } from "react-icons/fi";
import {AiFillCloseCircle} from "react-icons/ai"
import { Sidebar , UserProfile } from "../components/index";
import Pins from "./Pins";

const Home = () => {
    const User = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null;
    const [closeSideBar,setSideBar] = useState(false);
    const scrollRef = useRef(null);
    const closeSideBarNow = () => { setSideBar(!closeSideBar) };
    useEffect(() => {
        scrollRef.current.scrollTo(0, 0);
    });
    return (
        <div className="flex flex-col md:flex-row bg-gray-50 transition-height duration-75 ease-in-out">
            <div className="hidden md:flex h-screen flex-initial">
                { User && <Sidebar User={User} /> }
            </div>
            <div className="flex md:hidden flex-row">
                <div className="p-2 w-full flex flex-row justify-between items-center shadow-md">
                    <FiMenu fontSize={40} className="cursor_pointer" onClick={() => setSideBar(!closeSideBar)}/>
                    <Link to="/"><img src={logo} alt="..." className="w-28"/></Link>
                    { User && <Link to={`/user-profile/${User.googleId}`}><img src={User.imageUrl} alt="..." className="w-10 h-10 rounded-full"/></Link>}
                </div>
                {
                    closeSideBar &&
                    <div className="fixed w-2/5 bg-white h-screen overflow-y-auto shadow-md z-10 animate-slide-in">
                        <div className="absolute w-full flex justify-end items-center p-2">
                            <AiFillCloseCircle fontSize={30} className="cursor-pointer" onClick={() => setSideBar(!closeSideBar)} />
                        </div>
                        { User && <Sidebar User={User} closeSideBarNow={closeSideBarNow} /> }
                    </div>
                }
            </div>
            <div className="pb-2 flex-1 h-screen overflow-y-scroll" ref={scrollRef}>
            {
                    User &&
                    <Routes>
                        <Route path="/user-profile/:userId" element={<UserProfile />}></Route>
                        <Route path="/*" element={<Pins User={User} />}></Route>
                    </Routes>
                }
            </div>
        </div>
    )
};

export default Home;